import { intersect, nullable, number, partial, string, struct } from 'io-ts/Decoder';

export const Metadata = intersect(
	struct({
		mimeType: string,
		lastModified: string,
		fileSize: number,
	})
)(
	partial({
		numberOfPages: nullable(number),
		icommandJobNumber: string,
		alpineJsonJobName: string,
		contentHash: string,
	})
);
